export default __webpack_public_path__ + "static/32933-81c6bc200b35bb99a87a3a616905cee9.jpg";